import React, {useState} from 'react'
import {Lang} from 'yougile-lang'
import {ArrUtil} from 'yougile-util'
import {DataObjectId, Hub} from 'yougile-model'
import {Select} from '@components/common/base/select/index'
import {DropdownContent} from '@components/common/dropdown/dropdown-content'
import {UsersTable} from '@components/common/users-table/users-table'
import {getUsers} from '@components/sticker/my-stickers/board-stickers/sticker-settings/utils/get-users'
import {
  getUsersOptions,
  OptionsItem
} from '@components/sticker/my-stickers/board-stickers/sticker-settings/utils/get-users-options'
import {cn} from '@containers/html-utils'

export interface Props {
  disabled?: boolean
  width?: string
  onChange?: (users: DataObjectId[]) => void
  selectedUserIds?: DataObjectId[]
  placeholder?: string
  board: Hub
}

export const SelectWithUsers = (props: Props) => {
  const {onChange, selectedUserIds = [], board, width = 'w-320'} = props
  const [open, setOpen] = useState(false)

  const toggleUsers = (userKeys: DataObjectId[]) => {
    const newSelectedUserIds = ArrUtil.xorBy(selectedUserIds, userKeys, x => x)
    onChange([...newSelectedUserIds])
  }

  const users = board ? getUsers(board) : []
  const usersOptions = board ? getUsersOptions(users) : []

  const dropdownButtonText = getMultiSelectText({
    value: selectedUserIds,
    options: usersOptions
  })

  return (
    <Select
      content={
        <DropdownContent
          className={cn(width, 'h-304')}
          header={Lang.msg.coworkers}
        >
          <UsersTable
            className={cn(width, 'h-full')}
            users={users}
            useCheckbox={true}
            selected={selectedUserIds}
            onToggled={toggleUsers}
          />
        </DropdownContent>
      }
      open={open}
      onOpenChange={v => setOpen(v)}
      disabled={props.disabled}
      placeholder={props.placeholder ?? Lang.msg.myStickers.selectUser}
    >
      {dropdownButtonText}
    </Select>
  )
}

const getMultiSelectText = (props: {
  value: DataObjectId[]
  options: OptionsItem[]
}) => {
  const {value, options} = props
  const allText = Lang.msg.component.dropdown.all

  if (value.length === 0) {
    return undefined
  }
  if (value.length === options.length) {
    return allText || ''
  }
  if (value.length === 1) {
    return options.find(x => x.value === value[0])?.label
  }
  return `${Lang.msg.component.dropdown.selected} ${value.length} ${Lang.msg.component.dropdown.outOf} ${options.length}`
}
